document.addEventListener("DOMContentLoaded", () => {
  // Sprawdzenie, czy na stronie są elementy tabów i treści
  const tabs = document.querySelectorAll(".tab");
  const contents = document.querySelectorAll(".tab-content");

  if (tabs.length === 0 || contents.length === 0) {

    return; // Przerywa działanie, jeśli nie ma elementów
  }

  // Opcjonalnie: Domyślnie zaznacz pierwszy tab
  const defaultTab = document.querySelector(".tab.active") || tabs[0];
  defaultTab.classList.add("active");
  const selectedDefault = defaultTab.getAttribute("data-tab");
  contents.forEach((c) => {
    c.style.display = c.id === selectedDefault ? "block" : "none";
  });

  // Dodanie obsługi kliknięcia na tabach
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      // Warunek sprawdzający, czy kliknięty tab nie jest już aktywny
      if (tab.classList.contains("active")) {
        return; // nic nie rób, gdy już jest aktywny
      }

      // Usuwanie klasy aktywnej z wszystkich tabów
      tabs.forEach((t) => t.classList.remove("active"));
      // Dodanie klasy aktywnej do klikniętego tab'a
      tab.classList.add("active");

      const selected = tab.getAttribute("data-tab");
      // Pokazywanie odpowiedniej treści
      contents.forEach((c) => {
        c.style.display = c.id === selected ? "block" : "none";
      });
    });
  });

  // Opcjonalne: Funkcja, którą można wywołać po załadowaniu, np. do inicjalizacji
  function initTabs() {
    console.log("Taby zostały zainicjowane");
    // można tu dodać dodatkowe instrukcje np. ustawienia lub animacje
  }

  // Wywołanie funkcji inicjującej
  initTabs();
});
